import {
    captionClassName,
    labelClassName,
    buttonClassName,
    filterContentLayoutSlotClassNames,
    pxToRem,
    pxArrayToRem,
} from '@archipro-design/aria';

import type { StyleRule } from '@archipro-design/aria';
import { svgIconClassName } from '@archipro-design/icons';

export const DialogContentWrapper: StyleRule = ({ theme }) => ({
    '& *': {
        '-webkit-tap-highlight-color': 'transparent',
    },

    [`& .${captionClassName}`]: {
        color: theme.siteVariables.colors.charcoal['250'],
    },

    [`& .${filterContentLayoutSlotClassNames.headerAction}`]: {
        [`& .${buttonClassName}:hover`]: {
            textDecoration: 'none',
        },
        [`& .${labelClassName}`]: {
            color: theme.siteVariables.colors.charcoal['250'],
        },
    },

    [`& .${filterContentLayoutSlotClassNames.closeBtn}`]: {
        [`& .${svgIconClassName}`]: {
            '& svg': {
                fill: theme.siteVariables.colors.charcoal['250'],
            },
        },
    },

    [`& .${filterContentLayoutSlotClassNames.footer}`]: {
        [`& .${labelClassName}`]: {
            textTransform: 'uppercase',
        },
    },
});

export const SortFilterGrid: StyleRule = ({ theme }) => ({
    alignItems: 'start',
    gridTemplateRows: 'auto 1fr',
    [`& .${labelClassName}`]: {
        color: theme.siteVariables.colors.charcoal['250'],
    },
});

export const SortByWrapper: StyleRule = () => ({
    margin: pxArrayToRem([28, 0, 36, 0]),
});

export const FilterComponentWrapper: StyleRule = () => ({
    marginBottom: pxToRem(16),
});
